import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { createPlan } from "../../redux/slices/planSlice";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const CreatePlan = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: "",
        price: "",
        maxListings: "",
        maxLeads: "",
        durationDays: "",
        contact: "", // ✅ NEW FIELD
        verifiedBadge: "freemium",
        features: [""]
    });

    // 🔄 Handle input change
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    // 🔥 Feature change
    const handleFeatureChange = (index, value) => {
        const updated = [...formData.features];
        updated[index] = value;
        setFormData({ ...formData, features: updated });
    };

    // ➕ Add feature
    const addFeature = () => {
        setFormData({
            ...formData,
            features: [...formData.features, ""]
        });
    };

    // ❌ Remove feature
    const removeFeature = (index) => {
        const updated = formData.features.filter((_, i) => i !== index);
        setFormData({ ...formData, features: updated });
    };

    // 🚀 Submit
    const handleSubmit = async (e) => {
        e.preventDefault();

        // simple validation
        if (!formData.name || !formData.price) {
            Swal.fire("Error", "Name and Price are required", "error");
            return;
        }

        try {
            const res = await dispatch(createPlan(formData)).unwrap();

            Swal.fire({
                title: "Success 🎉",
                text: res.message,
                icon: "success",
                confirmButtonColor: "#3085d6"
            }).then(() => {
                navigate("/plans");
            });

        } catch (err) {
            Swal.fire("Error", err.message || "Something went wrong", "error");
        }
    };

    return (
        <div className="container mt-4">
            <div className="card shadow-lg border-0">

                {/* Header */}
                <div className="card-header bg-dark text-white">
                    <h4 className="mb-0 text-white">Create Plan</h4>
                </div>

                {/* Body */}
                <div className="card-body">

                    <form onSubmit={handleSubmit}>

                        <div className="row">

                            <div className="col-md-6 mb-3">
                                <label className="form-label">Plan Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    className="form-control"
                                    placeholder="Enter plan name"
                                    value={formData.name}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-6 mb-3">
                                <label className="form-label">Price (₹)</label>
                                <input
                                    type="number"
                                    name="price"
                                    className="form-control"
                                    placeholder="Enter price"
                                    value={formData.price}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-6 mb-3">
                                <label className="form-label">Max Listings</label>
                                <input
                                    type="number"
                                    name="maxListings"
                                    className="form-control"
                                    value={formData.maxListings}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-6 mb-3">
                                <label className="form-label">Max Leads</label>
                                <input
                                    type="number"
                                    name="maxLeads"
                                    className="form-control"
                                    value={formData.maxLeads}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* ✅ NEW CONTACT FIELD */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Contact Limit</label>
                                <input
                                    type="number"
                                    name="contact"
                                    className="form-control"
                                    placeholder="Enter contact limit"
                                    value={formData.contact}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-6 mb-3">
                                <label className="form-label">Verified Badge</label>
                                <select
                                    name="verifiedBadge"
                                    className="form-control"
                                    value={formData.verifiedBadge}
                                    onChange={handleChange}
                                >
                                    <option value="free">Free</option>
                                    <option value="basic">Basic</option>
                                    <option value="standard">Standard</option>
                                    <option value="premium">Premium</option>
                                </select>
                            </div>

                            <div className="col-md-6 mb-3">
                                <label className="form-label">Duration (Days)</label>
                                <input
                                    type="number"
                                    name="durationDays"
                                    className="form-control"
                                    placeholder="0 for unlimited"
                                    value={formData.durationDays}
                                    onChange={handleChange}
                                />
                            </div>

                        </div>

                        {/* 🔥 Features Section */}
                        <div className="mb-3">
                            <label className="form-label">Features</label>

                            {formData.features.map((feature, index) => (
                                <div className="d-flex mb-2" key={index}>
                                    <input
                                        type="text"
                                        className="form-control me-2"
                                        placeholder={`Feature ${index + 1}`}
                                        value={feature}
                                        onChange={(e) => handleFeatureChange(index, e.target.value)}
                                    />

                                    <button
                                        type="button"
                                        className="btn btn-danger me-2"
                                        onClick={() => removeFeature(index)}
                                    >
                                        ❌
                                    </button>

                                    {index === formData.features.length - 1 && (
                                        <button
                                            type="button"
                                            className="btn btn-success"
                                            onClick={addFeature}
                                        >
                                            ➕
                                        </button>
                                    )}
                                </div>
                            ))}
                        </div>

                        {/* Submit */}
                        <button type="submit" className="btn btn-primary w-100">
                            Create Plan
                        </button>

                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreatePlan;